<template>
  <div>
    <div class="pageBox">
      <!-- 订单 -->
      <div class="orderManagementPage">
        <div class="pageHeader">
          <div class="typeBtns">
            <div
              v-for="(item, index) in typeList"
              :key="index"
              class="typBtn"
              :class="currentTab == item.id ? 'activeBl' : ''"
              @click="changeTab(item.id)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="search">
            <el-input
              clearable
              placeholder="请输入商品名称"
              v-model="storeName"
              class="input-with-select"
              suffix-icon="el-icon-search"
              @input.native="storeName = storeName.replace(/\*+/g, '')"
              @change="init"
            ></el-input>
          </div>
        </div>

        <div class="orderList" v-loading="loading">
          <div class="orderListHeader">
            <el-row>
              <el-col :span="8">
                <div class="listHeaderName">订单信息</div>
              </el-col>
              <el-col :span="2">
                <div class="listHeaderName">状态</div>
              </el-col>
              <el-col :span="2">
                <div class="listHeaderName">单价</div>
              </el-col>
              <el-col :span="2">
                <div class="listHeaderName">数量</div>
              </el-col>
              <el-col :span="2">
                <div class="listHeaderName">运费</div>
              </el-col>
              <el-col :span="3">
                <div class="listHeaderName">总价</div>
              </el-col>
              <el-col :span="5">
                <div class="listHeaderName">操作</div>
              </el-col>
            </el-row>
          </div>
    
          <div class="orderListC" v-if="dataList.length > 0">
            <div class="orderListItem" v-for="(item, index) in dataList" :key="index">
              <div class="itemHeader">
                <div class="time">{{ item.orderDetail.updateTime | dateFormate }}</div>
                <div class="orderId">订单编号：{{ item.orderCode }}</div>
                <div class="copyBtn" v-clipboard:copy="item.orderCode" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</div>
                <div class="tab">
                  <img v-if="item.orderDetail.storeType === 'U'" class="tabIcon" src="@/assets/images/pt/yxdp.png" />
                  <img v-if="item.orderDetail.storeType === 'S'" class="tabIcon" src="@/assets/images/pt/zy.png" />
                </div>
                <div class="title">{{ item.orderDetail.storeName }}</div>
                <div class="detail" @click="goDetail(item)">{{  currentTab == '6' || item.orderDetail.orderStatus == 5 ||
                            item.orderDetail.orderStatus == 6 ||
                            item.orderDetail.orderStatus == 8 ||
                            item.orderDetail.auditStatus == 4 ? '退款详情' : '订单详情'}}<i class="el-icon-arrow-right"></i></div>
              </div>
              <div class="itemContent">
                <el-row>
                  <!-- 订单信息 -->
                  <el-col :span="8">
                    <div class="itemContentBox">
                      <img class="goodsImg" :src="item.orderDetail.commodityImg" />
                      <div class="rCon">
                        <div class="title">{{ item.orderDetail.commodityName }}</div>
                        <div class="sku">{{ item.orderDetail.skuInfo.replace(/\|/g, ' ') }}</div>
                        <div class="activeC">
                          <div class="activeMsg" v-if="item.orderType === 'M'">
                            <div class="activeType">{{ item.orderType | getGroupName }}</div>
                          </div>
                          <div class="activeMsg" v-if="item.orderType === '1' || item.orderType === '2' || item.orderType === '3'">
                            <div class="activeType">{{ item.orderType | getGroupName }}</div>
                            <div class="activeNum">{{ item.groupPeopleText }}人团购</div>
                          </div>
                          <!-- 待发货状态下不显示 -->
                          <div class="lessNum" v-if="(item.orderType === '1' || item.orderType === '2' || item.orderType === '3') && item.groupPeople && item.currentMembers && item.groupPeople - item.currentMembers > 0 && item.orderDetail.orderStatus != '1'">
                            已拼成{{ item.currentMembers }}人差{{ item.groupPeople - item.currentMembers }}人拼成
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <!-- 状态 -->
                  <el-col :span="2">
                    <div class="textContent">
                      <span v-if="item.orderDetail.returnStatus && item.orderDetail.returnStatus != '3' && item.orderDetail.returnStatus != '1'">
                        {{ item.orderDetail.returnStatus | returnStatusFormat }}
                      </span>
                      <!-- 退款售后列表展示退款状态 -->
                      <span v-else-if="item.orderDetail.auditStatus && currentTab == '6'">
                        {{ item.orderDetail.auditStatus | auditStatusFormat }}
                      </span>
                      <!-- 订单列表退款状态不展示已取消,退款已取消状态展示订单状态 -->
                      <span v-else-if="item.orderDetail.auditStatus && item.orderDetail.auditStatus != '1' && currentTab != '6'">
                        {{ item.orderDetail.auditStatus | auditStatusFormat }}
                      </span>
                      <span v-else>
                        {{ item.orderDetail.orderStatus | statusFormat }}
                      </span>
                    </div>
                  </el-col>
                  <!-- 单价 -->
                  <el-col :span="2">
                    <div class="textContent">
                      <span v-if="item.orderDetail.payMethod === '1'">¥{{ formatMoney(item.orderDetail.price) }}</span>
                      <span v-else>{{ formatMoney(item.orderDetail.price) }}提货值</span>
                    </div>
                  </el-col>
                  <!-- 数量 -->
                  <el-col :span="2">
                    <div class="textContent">{{ item.orderDetail.quantity }}</div>
                  </el-col>
                  <!-- 运费 -->
                  <el-col :span="2">
                    <div class="textContent">￥{{ formatMoney(item.orderDetail.shippingFee || 0) }}</div>
                  </el-col>
                  <!-- 总价 -->
                  <el-col :span="3">
                    <div class="textContent">
                      <span class="value" v-if="item.orderDetail.payMethod === '1'"
                        >¥ {{ formatMoney(calculateOrderTotal(item.orderDetail.price, item.orderDetail.quantity, item.orderDetail.shippingFee)) }}</span
                      >
                      <span class="value" v-else>
                        {{ formatMoney(calculateOrderTotal(item.orderDetail.price, item.orderDetail.quantity)) }}
                        提货值
                        <span v-if="formatMoney(item.orderDetail.shippingFee) > 0"> + ¥ {{ formatMoney(item.orderDetail.shippingFee || 0) }} </span>
                      </span>
                    </div>
                  </el-col>
                  <!-- 操作 -->
                  <el-col :span="5">
                    <div class="itemContentBtns">
                      <!-- 第一行 -->
                      <div class="btns">
                        <!-- 待付款 立即支付 -->
                        <div v-if="item.orderDetail.orderStatus == 0" class="payBtn" @click.stop="handlePayment(item)">立即支付</div>
    
                        <!-- 拼团 邀请好友 -->
                        <!-- <div class="payBtn" v-if="item.orderDetail.orderStatus == 10">邀请好友<span>请在手机端操作</span></div> -->
    
                        <!-- 申请退款 -->
                        <div
                          v-if="item.orderDetail.orderStatus == 1 && (!item.orderDetail.returnStatus || item.orderDetail.returnStatus === '3')"
                          class="payBtn payBtn1"
                          @click.stop="applyRefund(item)"
                        >
                          申请退款
                        </div>
                        <!-- 查看物流 -->
                        <div
                          v-if="item.orderDetail.orderStatus == 2 || item.orderDetail.orderStatus == 3"
                          class="payBtn payBtn1"
                          @click.stop="seeLogistics(item)"
                        >
                          查看物流
                        </div>
                        <!-- 确认收货 -->
                        <div v-if="item.orderDetail.orderStatus == 2" class="payBtn" @click.stop="goDetail(item)">确认收货</div>
                        <!-- 再次购买 跳转商品详情 -->
                        <div v-if="item.orderDetail.orderStatus == 4 || item.orderDetail.orderStatus == 3" class="payBtn" @click.stop="goBuyAgain(item)">
                          再次购买
                        </div>
                        <!-- 退款详情 -->
                        <!-- <div
                          v-show="currentTab != '6'"
                          v-if="
                            item.orderDetail.orderStatus == 5 ||
                            item.orderDetail.orderStatus == 6 ||
                            item.orderDetail.orderStatus == 8 ||
                            item.orderDetail.auditStatus == 4
                          "
                          class="payBtn payBtn1"
                          @click.stop="goRefundDetail(item)"
                        >
                          退款详情
                        </div> -->
                        <!-- 撤销退款申请 -->
                        <div
                          v-if="(item.orderDetail.orderStatus == 5 && item.orderDetail.returnStatus == '0') || item.orderDetail.auditStatus == 2"
                          class="payBtn"
                          @click.stop="goRefundDetail(item)"
                        >
                          撤销申请
                        </div>
                        <!-- 重新申请退款 -->
                        <div
                          v-if="(item.orderDetail.orderStatus == 1 && item.orderDetail.returnStatus == '1') || item.orderDetail.auditStatus == 3"
                          class="payBtn payBtn1"
                          @click.stop="applyRefund(item)"
                        >
                          重新申请
                        </div>
                      </div>
                      <!-- 第二行 -->
                      <div class="timeStamp">
                        <span v-if="item.orderDetail.orderStatus === 0">剩余时间: {{ item.countdownText }}</span>
                        <span v-if="item.orderDetail.orderStatus === 10">距结束: {{ item.countdownText }}</span>
                      </div>
                      <!-- 站位行 -->
                      <div class="none"></div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <div class="orderListC" v-else>
            <el-empty :image-size="200"></el-empty>
          </div>
    
          <el-pagination
            v-show="settlementDatasInfinite.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="settlementDatasInfinite.currentPage"
            :page-sizes="[10, 20, 40, 100]"
            :page-size="settlementDatasInfinite.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="settlementDatasInfinite.total"
          >
          </el-pagination>
    
          <!-- 付款弹窗 -->
          <payDialog ref="payPop" @surePay="surePay" @closePay="closePay" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*global http protocolPt protocol util */
import payDialog from '@/components/base/payDialog/payDialog.vue' // 支付弹窗
export default {
  components: {
    payDialog
  },
  filters: {
    getGroupName(val) {
      switch (val) {
        case '1':
          return '普通拼团'
        case '2':
          return '阶梯拼团'
        case '3':
          return '超级拼团'
        case 'M':
          return '限时秒杀'
        default:
          return ''
      }
    },
    // 订单状态
    statusFormat(id) {
      let statusName = null
      switch (id) {
        case 0:
          statusName = '待付款'
          break
        case 1:
          statusName = '待发货'
          break
        case 2:
          statusName = '待收货'
          break
        case 3:
          statusName = '已完成'
          break
        case 4:
          statusName = '交易关闭'
          break
        case 5:
          statusName = '退款申请中'
          break
        case 6:
          statusName = '已退款'
          break
        case 7:
          statusName = '已删除'
          break
        case 8:
          statusName = '缺货退款'
          break
        case 9:
          statusName = '更换地址申请审核'
          break
        case 10:
          statusName = '拼团中'
          break
        case 11:
          statusName = '拼团失败'
          break
        default:
          statusName = '--'
          break
      }
      return statusName
    },
    // 售后订单状态
    returnStatusFormat(id) {
      let statusName = null
      switch (id) {
        case '0':
          statusName = '待审核'
          break
        case '1':
          statusName = '已驳回'
          break
        case '2':
          statusName = '已退款'
          break
        case '3':
          statusName = '已取消'
          break
        default:
          statusName = '--'
          break
      }
      return statusName
    },
    auditStatusFormat(id) {
      let statusName = null
      switch (id) {
        case 1:
          statusName = '已取消'
          break
        case 2:
          statusName = '待审核'
          break
        case 3:
          statusName = '已驳回'
          break
        case 4:
          statusName = '已退款'
          break
        case 5:
          statusName = '缺货退款'
          break
        default:
          statusName = '--'
          break
      }
      return statusName
    }
  },
  computed: {
    typeList() {
      const list = [
        { name: '全部', id: '12' },
        { name: '待付款', id: '13' },
        { name: '拼团中', id: '10' },
        { name: '待发货', id: '1' },
        { name: '待收货', id: '2' },
        { name: '已完成', id: '3' },
        { name: '退款/售后', id: '6' }
      ]
      return this.ACTIVITY_FLAG ? list : list.filter(item => item.id !== '10')
    }
  },
  data() {
    return {
      ACTIVITY_FLAG: window.g.ACTIVITY_FLAG,
      storeName: '',
      currentTab: '12',
      searchValue: '',
      isHave: true,
      finishedText: '加载中',
      // 分页相关
      settlementDatasInfinite: {
        total: null,
        pageSize: 10,
        currentPage: 1,
        isGetRespond: true
      },
      dataList: [],
      loading: false,
      finished: false,
      statusObj: {
        orderStatus: null,
        payStatus: null,
        orderStatusList: null
      },
      // 存储每个订单的倒计时定时器
      countdownTimers: {},
      payDisable: false, // 点击支付防重
      sucessShow: false,
      applyObj: {},
      isPwdPay: true, // 固定值 window.g.isPwdPay
      leaveValue: '', // 买家留言,暂不支持修改
      isRepeat: false
    }
  },
  mounted() {
    this.currentTab = this.$route.params.typeIndex || '12'
    this.changeTab(this.currentTab)
  },
  beforeDestroy() {
    // 组件销毁前清除所有倒计时定时器
    this.clearAllCountdowns()
  },
  methods: {
    // 格式化金额显示（保留两位小数）
    formatMoney(amount) {
      return Number(amount).toFixed(2)
    },
    // 计算订单合计（商品总价 + 运费）
    calculateOrderTotal(price, quantity, shippingFee) {
      const totalPrice = this.moneyMultiply(Number(price) || 0, Number(quantity) || 0)
      const shipping = Number(shippingFee) || 0
      return this.moneyAdd(totalPrice, shipping)
    },
    // 金额乘法（处理精度问题）
    moneyMultiply(num1, num2) {
      const factor = 100 // 转换为分
      const int1 = Math.round(num1 * factor)
      const result = (int1 * num2) / factor
      return Math.round(result * 100) / 100 // 保留两位小数
    },
    // 金额加法（处理精度问题）
    moneyAdd(num1, num2) {
      const factor = 100 // 转换为分
      const int1 = Math.round(num1 * factor)
      const int2 = Math.round(num2 * factor)
      return (int1 + int2) / factor
    },
    onCopy(e) {
      this.$message.success('你复制了：' + e.text)
    },
    onError(e) {
      this.$message.error(e.text)
    },
    changeTab(tab) {
      if (this.isHave) {
        this.currentTab = tab
        if (this.currentTab === '13') {
          // 待付款
          this.statusObj.orderStatus = 0
          this.statusObj.payStatus = 0
          this.statusObj.orderStatusList = null
        } else if (this.currentTab === '1') {
          // 待发货
          this.statusObj.orderStatus = 1
          this.statusObj.payStatus = 1
          this.statusObj.orderStatusList = null
        } else if (this.currentTab === '2') {
          // 待收货
          this.statusObj.orderStatus = 2
          this.statusObj.payStatus = 1
          this.statusObj.orderStatusList = null
        } else if (this.currentTab === '3') {
          // 已完成
          this.statusObj.orderStatus = 3
          this.statusObj.orderStatusList = null
          this.statusObj.payStatus = null
        } else if (this.currentTab === '6') {
          this.statusObj.orderStatus = 6
          this.statusObj.payStatus = 1
          this.statusObj.orderStatus = null
          this.statusObj.orderStatusList = [5, 6, 7, 8, 11]
        } else if (this.currentTab === '10') {
          this.statusObj.orderStatus = 10
          this.statusObj.payStatus = 1
          this.statusObj.orderStatusList = null
        } else {
          // 全部
          this.statusObj.orderStatus = null
          this.statusObj.payStatus = null
          this.statusObj.orderStatusList = null
        }
        this.init()
        if (this.$route.fullPath !== `/orderManagement/${tab}`) {
          this.$router.push(`/orderManagement/${tab}`);
        }
      }
    },
    // 修改每页条数
    handleSizeChange(val) {
      this.settlementDatasInfinite.pageSize = val
      console.log(`每页 ${val} 条`)
      this.getOrderList()
    },
    // 修改页数
    handleCurrentChange(val) {
      this.settlementDatasInfinite.currentPage = val
      console.log(`当前页: ${val}`)
      this.getOrderList()
    },
    init() {
      this.isHave = false
      this.finishedText = '加载中'
      this.dataList = []
      this.loading = false
      this.finished = false
      this.settlementDatasInfinite = {
        total: 0,
        pageSize: 10,
        currentPage: 1,
        isGetRespond: true
      }
      // 清除所有倒计时
      this.clearAllCountdowns()
      this.getOrderList()
    },
    // 获取订单列表
    getOrderList() {
      this.loading = true
      this.settlementDatasInfinite.isGetRespond = false
      let protocolUrlData = {}
      if (this.currentTab === '6') {
        protocolUrlData = JSON.parse(JSON.stringify(protocolPt.param_queryGoodBackList))
      } else {
        protocolUrlData = JSON.parse(JSON.stringify(protocolPt.param_queryShopOrderInfo))
      }
      protocolUrlData.param.sort = [
        {
          direction: 'DESC',
          property: 'updateTime'
        }
      ]
      protocolUrlData.param.page = this.settlementDatasInfinite.currentPage - 1
      protocolUrlData.param.size = this.settlementDatasInfinite.pageSize
      protocolUrlData.param.orderStatus = this.statusObj.orderStatus
      protocolUrlData.param.commodityName = this.storeName
      protocolUrlData.param.orderStatusList = this.statusObj.orderStatusList
      protocolUrlData.param.payStatus = this.statusObj.payStatus
      protocolUrlData.param.mallFlag = null
      http
        .postFrontMall(protocolUrlData)
        .then((response) => {
          const { code, message, value } = response.data
          this.settlementDatasInfinite.isGetRespond = true
          this.loading = false
          this.isHave = true
          if (code === 0 || code === '0') {
            this.settlementDatasInfinite.total = value.totalElements
            if (this.currentTab === '6') {
              for (let m = 0; m < value.content.length; m++) {
                value.content[m].orderDetail = {
                  ...value.content[m]
                }
              }
            } else {
              for (let m = 0; m < value.content.length; m++) {
                if (value.content[m].orderDetailMongos && value.content[m].orderDetailMongos.length > 0) {
                  value.content[m].orderDetail = value.content[m].orderDetailMongos[0]
                } else {
                  value.content[m].orderDetail = {
                    skuInfo: '',
                    storeType: '',
                    shippingFee: '',
                    quantity: '',
                    commodityImg: '',
                    price: 0,
                    amount: 1,
                    orderStatus: 0,
                    orderDetailId: '',
                    logisticsNumber: '',
                    logisticsCompany: '',
                    payMethod: ''
                  }
                }
              }
            }
            // if (this.dataList.length !== 0) {
            //   this.dataList = [...this.dataList, ...value.content]
            // } else {
            //   this.dataList = value.content
            // }
            this.dataList = value.content
            // 数据加载完成后，启动所有待付款订单和拼团中订单的倒计时
            this.$nextTick(() => {
              this.dataList.forEach((item) => {
                if (item.orderDetail.orderStatus === 0 && item.paymentDeadline) {
                  this.startCountdown(item, 'paymentDeadline')
                }
                if (item.orderDetail.orderStatus === 10 && item.groupDeadline) {
                  this.startCountdown(item, 'groupDeadline')
                }
              })
            })
            if (value.totalElements === 0) {
              this.finished = true
              this.finishedText = ''
              return
            } else {
              this.finishedText = '没有更多了'
            }
            if (value.last === true) {
              this.finished = true
            } else {
              this.finished = false
            }
          } else {
            this.loading = false
            this.finished = true
            this.dataList = []
            this.$message(message)
          }
        })
        .catch((e) => {
          this.loading = false
          this.finished = true
          this.$message('与服务器的网络连接失败!')
          this.isHave = true
        })
    },
    // 格式化倒计时显示
    formatCountdown(seconds) {
      if (seconds <= 0) return '00:00:00'
      const hours = Math.floor(seconds / 3600)
      const minutes = Math.floor((seconds % 3600) / 60)
      const secs = seconds % 60
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
    },
    // 启动倒计时
    startCountdown(item, deadlineField = 'paymentDeadline') {
      // 如果已经有定时器，先清除
      if (this.countdownTimers[item.orderId]) {
        clearInterval(this.countdownTimers[item.orderId])
      }
      // 计算剩余秒数 - 根据传入的字段名获取截止时间
      const deadline = new Date(item[deadlineField]).getTime()
      const now = new Date().getTime()
      let remainingSeconds = Math.floor((deadline - now) / 1000)
      if (remainingSeconds <= 0) {
        this.$set(item, 'countdownText', '00:00:00')
        return
      }
      // 设置初始倒计时文本
      this.$set(item, 'countdownText', this.formatCountdown(remainingSeconds))
      // 启动定时器
      this.countdownTimers[item.orderId] = setInterval(() => {
        remainingSeconds--
        if (remainingSeconds <= 0) {
          clearInterval(this.countdownTimers[item.orderId])
          delete this.countdownTimers[item.orderId]
          this.$set(item, 'countdownText', '00:00:00')
          // 倒计时结束，刷新数据
          this.getOrderList()
        } else {
          this.$set(item, 'countdownText', this.formatCountdown(remainingSeconds))
        }
      }, 1000)
    },
    // 清除所有倒计时
    clearAllCountdowns() {
      Object.keys(this.countdownTimers).forEach((orderId) => {
        clearInterval(this.countdownTimers[orderId])
      })
      this.countdownTimers = {}
    },
    // 支付
    handlePayment(orderItem) {
      if (this.payDisable) {
        this.$message.warning('请求中, 请稍候再试')
        return
      }
      this.payDisable = true
      // 记录订单信息
      this.applyObj = orderItem
      // 显示弹窗
      const typeName = '支付余额'
      const totalPrice =
        orderItem.orderDetail.payMethod === '1'
          ? '¥' +
            this.formatMoney(this.calculateOrderTotal(orderItem.orderDetail.price, orderItem.orderDetail.quantity, orderItem.orderDetail.shippingFee))
          : this.formatMoney(this.calculateOrderTotal(orderItem.orderDetail.price, orderItem.orderDetail.quantity)) +
            '提货值' +
            (this.formatMoney(orderItem.orderDetail.shippingFee) > 0 ? ` + ¥${this.formatMoney(orderItem.orderDetail.shippingFee || 0)}` : '')
      console.log(totalPrice, this.$refs, 'totalPrice')
      this.$refs.payPop.showSheet(totalPrice, typeName)
    },
    // 支付
    surePay(pwd) {
      if (this.applyObj.orderType === 'N') {
        this.payOrder(pwd)
      } else if (this.applyObj.orderType === 'M') {
        this.payOrderSeckill(pwd)
      } else {
        this.payOrderSuper(pwd)
      }
    },
    // 取消支付
    closePay() {
      this.payDisable = false
      this.$refs.payPop.showPop = false
    },
    // 支付
    payOrder(pwd) {
      const params = {
        addressId: this.selectedAddressId,
        commodityId: this.applyObj.orderDetail.commodityId,
        payType: this.applyObj.orderDetail.payMethod,
        quantity: this.applyObj.orderDetail.quantity,
        password: util.getmd5('47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + pwd),
        bankId: window.g.BANK_ID,
        message: this.leaveValue,
        orderCode: this.applyObj.orderCode
      }
      protocolPt.param_payOrderIntegral.param = params

      http
        .postFrontMall(protocolPt.param_payOrderIntegral)
        .then((response) => {
          const { code, message } = response.data
          this.payDisable = false
          if (Number(code) === 0) {
            // 支付成功
            this.$message.success(message)
            this.$refs.payPop.showPop = false
            setTimeout(() => {
              this.init()
            }, 1000)
          } else {
            this.$refs.payPop.showPop = false
            this.$message.error(message)
          }
        })
        .catch(() => {
          this.payDisable = false
        })
    },
    payOrderSuper(pwd) {
      const params = {
        activityId: this.applyObj.activityId,
        addressId: this.applyObj.addressId,
        commodityId: this.applyObj.orderDetail.commodityId,
        payType: this.applyObj.orderDetail.payMethod,
        quantity: this.applyObj.orderDetail.quantity,
        password: util.getmd5('47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + pwd),
        bankId: window.g.BANK_ID,
        message: this.leaveValue,
        orderCode: this.applyObj.orderCode,
        groupId: this.applyObj.groupId
      }
      protocolPt.param_payGroupon.param = params
      http
        .postFrontMall(protocolPt.param_payGroupon)
        .then((response) => {
          const { code, message, value } = response.data
          this.payDisable = false
          if (Number(code) === 0) {
            // 支付成功
            this.$refs.payPop.showPop = false
            this.$message.success(message)
            setTimeout(() => {
              this.init()
            }, 1000)
          } else {
            this.$refs.payPop.showPop = false
            this.$message.error(message)
          }
        })
        .catch(() => {
          this.payDisable = false
        })
    },
    payOrderSeckill(pwd) {
      const params = {
        activityId: this.applyObj.activityId,
        addressId: this.applyObj.addressId,
        commodityId: this.applyObj.orderDetail.commodityId,
        payType: this.applyObj.orderDetail.payMethod,
        quantity: this.applyObj.orderDetail.quantity,
        password: util.getmd5('47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + pwd),
        bankId: window.g.BANK_ID,
        message: this.leaveValue,
        orderCode: this.applyObj.orderCode
      }
      protocol.param_payOrderSeckill.param = params
      http
        .postFrontMall(protocol.param_payOrderSeckill)
        .then((response) => {
          const { code, message, value } = response.data
          this.payDisable = false
          if (Number(code) === 0) {
            // 支付成功
            this.$refs.payPop.showPop = false
            this.$message.success(message)
            setTimeout(() => {
              this.init()
            }, 1000)
          } else {
            this.$refs.payPop.showPop = false
            this.$message.error(message)
          }
        })
        .catch(() => {
          this.payDisable = false
        })
    },
    // 订单详情
    goDetail(item) {
      // 存储详情
      console.log('详情', item)
      this.$store.commit('setSelectOrderDetail', item)
      if (
        this.currentTab == '6' ||
        item.orderDetail.orderStatus == 5 ||
        item.orderDetail.orderStatus == 6 ||
        item.orderDetail.orderStatus == 8 ||
        item.orderDetail.auditStatus == 4
      ) {
        // 退款售后 进退款详情
        this.$router.push('/refundDetail')
      } else {
        this.$router.push('/orderDetail')
      }
    },
    // 再次购买
    goBuyAgain(item) {
      console.log(item)
      if (item.orderType === 'N') {
        this.$router.push({
          name: 'ptOrdinaryGoodDetail',
          query: {
            commodityId: item.orderDetail.commodityId,
            storeId: item.storeId
          }
        })
      } else if (item.orderType === 'M') {
        // this.$router.push({
        //   name: 'timeLimitDetail',
        //   params: {
        //     activityId: item.activityId,
        //     commodityId: item.orderDetailMongos[0].commodityId
        //   }
        // })
        // 跳转普通商品
        this.$router.push({
          name: 'ptOrdinaryGoodDetail',
          query: {
            commodityId: item.orderDetail.commodityId,
            storeId: item.orderDetail.storeId
          }
        })
      } else {
        // 跳转普通商品
        this.$router.push({
          name: 'ptOrdinaryGoodDetail',
          query: {
            commodityId: item.orderDetail.commodityId,
            storeId: item.orderDetail.storeId
          }
        })
      }
    },
    // 申请退款
    applyRefund(item) {
      // 存储详情
      console.log('详情', item)
      this.$store.commit('setSelectOrderDetail', item)
      this.$router.push('/applyRefund')
    },
    // 退款详情
    goRefundDetail(item) {
      // 存储详情
      console.log('详情', item)
      this.$store.commit('setSelectOrderDetail', item)
      this.$router.push('/refundDetail')
    },
    // 查看物流
    seeLogistics(item) {
      if (!this.isRepeat) {
        this.isRepeat = true
      } else {
        this.$message.warning('请求发送中,请稍候再试')
        return
      }
      protocolPt.param_getLogistic.param.no = item.orderDetail.logisticsNumber + ':' + item.orderDetail.storeCellphone.slice(-4)
      protocolPt.param_getLogistic.param.type = item.orderDetail.logisticsCompany
      http
        .postFrontMall(protocolPt.param_getLogistic)
        .then(response => {
          this.isRepeat = false
          const { code, message, value } = response.data
          if (code === 0 || code === '0') {
            console.log(value, '物流信息');
            this.$message.success(message)
          } else {
            this.$message.error(message)
          }
        })
        .catch(() => {
          this.isRepeat = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.pageBox{
  height: calc(100vh - 40px);
  overflow-y: auto;
  overflow-x: hidden;
}
.orderManagementPage {
  width: 1200px;
  // height: 100%;
  margin: 34px auto;
  // background: #fff;
  .btn {
    cursor: pointer;
  }
  .pageHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .typeBtns {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 24px;
      .typBtn {
        height: 25px;
        font-family: PingFang TC, PingFang TC;
        font-weight: 400;
        font-size: 18px;
        color: #333333;
        text-align: left;
        font-style: normal;
        text-transform: none;

        cursor: pointer;
      }
      .activeBl {
        color: #1571db;
        position: relative;
      }
      .activeBl::after {
        position: absolute;
        content: '';
        width: 100%;
        height: 2px;
        bottom: -5px;
        left: 0;
        background: #1571db;
      }
    }
    .search {
      display: flex;
      align-items: center;
      width: 484px;
      height: 44px;
      .el-input__inner {
        border: 1px solid #000000;
      }
    }
  }

  .orderList {
    margin-top: 24px;
    .orderListHeader {
      background: #f4f4f4;
      height: 44px;
      .listHeaderName {
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: PingFang TC, PingFang TC;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }
  }

  .orderListC {
    margin-top: 10px;
    .orderListItem {
      .itemHeader {
        height: 40px;
        padding: 10px;
        box-sizing: border-box;
        background: #f4f4f4;
        display: flex;
        align-items: center;
        .time {
          display: flex;
          align-items: center;
          font-family: PingFang TC, PingFang TC;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
        }
        .orderId {
          margin-left: 15px;
          font-family: PingFang TC, PingFang TC;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
        }
        .copyBtn {
          margin-left: 10px;
          width: 44px;
          height: 24px;
          background: #ffffff;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #00000021;
          font-family: PingFang TC, PingFang TC;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
        .tab {
          margin-left: 20px;
          display: flex;
          align-items: center;
          .tabIcon {
            height: 16px;
          }
        }
        .title {
          margin-left: 10px;
          font-family: PingFang TC, PingFang TC;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
          flex: 1;
        }
        .detail {
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 5px;
          font-family: PingFang TC, PingFang TC;
          font-weight: 400;
          font-size: 14px;
          color: #666666;
          .el-icon-arrow-right {
            font-size: 10px;
            display: flex;
            align-items: center;
          }
        }
      }
      .itemContent {
        border: 1px solid #00000010;
        border-top: none;
        padding: 14px 0px;
        .itemContentBox {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          gap: 10px;
          width: 100%;
          flex-grow: 0;
          flex-shrink: 0;
          .goodsImg {
            flex-grow: 0;
            flex-shrink: 0;
            width: 62px;
            height: 62px;
            background: #d9d9d9;
            border-radius: 2px 2px 2px 2px;
            margin-left: 10px;
          }
          .rCon {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 62px;

            .title {
              font-family: PingFang TC, PingFang TC;
              font-weight: 400;
              font-size: 14px;
              color: #333333;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 340px;
            }
            .sku {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #999999;
              line-height: 19px;
            }
            .activeC {
              display: flex;
              align-items: center;
              gap: 8px;
              height: 20px;
              min-width: 10px;
              .activeMsg {
                display: flex;
                align-items: center;
                height: 18px;
                background: #ffffff;
                border-radius: 2px 2px 2px 2px;
                border: 1px solid rgba(235, 102, 67, 0.7);
                .activeType {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  background: #ffe3de;
                  font-family: PingFang SC, PingFang SC;
                  font-weight: 400;
                  font-size: 12px;
                  color: #eb6643;
                  line-height: 16px;
                  padding: 0 4px;
                }
                .activeNum {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  font-family: PingFang SC, PingFang SC;
                  font-weight: 400;
                  font-size: 12px;
                  color: #eb6643;
                  line-height: 16px;
                  padding: 0 8px;
                }
              }
              .lessNum {
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #eb6643;
                line-height: 19px;
              }
            }
          }
        }
        .textContent,
        .textContent span {
          font-family: PingFang TC, PingFang TC;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          text-align: center;
        }
        .itemContentBtns {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          height: 62px;
          .btns {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            height: 19px;
            .operateBtn,
            .payBtn {
              cursor: pointer;
              font-family: PingFang TC, PingFang TC;
              font-weight: 400;
              font-size: 14px;
              color: #1571db;
            }
          }
          .timeStamp,
          .timeStamp span {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 19px;
            min-width: 10px;

            font-family: PingFang TC, PingFang TC;
            font-weight: 400;
            font-size: 14px;
            color: #eb6643;
          }
          .none {
            width: 10px;
            height: 20px;
          }
        }
      }
    }
  }
}
</style>
